export class SystemUser {
  systemUserId?: number;
  clientITProfileId?: number;
  name?: string;
  role?: string;
  reviewedDate?: Date;
  lastLoginDate?: Date;
}
